interface IInsurer {
    id: string;
    name: string;
}

export function InsurerBlock(props: { insurer: IInsurer }) {
    return (
        <ul>
            <li>{props.insurer.name}</li>
        </ul>
    );
}
